module.exports = __webpack_public_path__ + "static/media/Joakim-Johansson.0fb307a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/Joakim-Johansson.jpg
// module id = 98
// module chunks = 0